import React from "react";
import { bot } from "../Assets";


const TgBot = () => {
  return (
    <div className=" min-h-screen flex items-center justify-center ">
      <main>
        <div className="max-w-screen-xl mx-auto px-4 flex items-center justify-start h-96 md:px-8">
          <div className="max-w-lg mx-auto space-y-3 flex flex-col items-center text-center">
            <img
              src={bot}
              alt="bot"
              className="w-32  lg:w-48"
            />
            <h3 className="text-slate-50 text-3xl font-semibold sm:text-5xl">
              Nads Trading Bot
            </h3>
            <p className="text-slate-50/70 ">
            The leading Telegram Trading Bot on monad
. Built for Nads, by Nads. 

            </p>
            <div className="flex items-center">
              <a
                href="https://x.com/NadsTradingBot"
                className="text-white duration-150 hover:text-yellow font-medium inline-flex items-center gap-x-1"
                target="_blank"
              >
                  <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="16" 
      height="16" 
      fill="currentColor" 
      className="bi bi-twitter-x" 
      viewBox="0 0 16 16"
    >
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
    </svg>
              </a>
              &nbsp;
              &nbsp;
              &nbsp;
              &nbsp;
              <a
                href="https://t.me/nadstradebot"
                className="text-amber-100 duration-150 hover:text-yellow font-medium inline-flex items-center gap-x-1"
                target="_blank"
              >
                try it out
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M5 10a.75.75 0 01.75-.75h6.638L10.23 7.29a.75.75 0 111.04-1.08l3.5 3.25a.75.75 0 010 1.08l-3.5 3.25a.75.75 0 11-1.04-1.08l2.158-1.96H5.75A.75.75 0 015 10z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default TgBot;
